import { Button, Stack } from "@mui/material";
import React, { useCallback } from "react";
import { AllResourcesLayout } from "./all-resources-layout";
import { useNavigate } from "react-router-dom";
export const ResourcesPage = () => {
    const navigate = useNavigate();
    const addResource = useCallback(() => {
        navigate("/addResource");
    }, []);
    const goToArchivedResources = React.useCallback(() => {
        navigate("/archived-resources");
    }, [navigate]);
    return (React.createElement(Stack, { direction: "column", alignItems: "center", padding: 3, spacing: 2, style: { flex: 1, overflow: "hidden" } },
        React.createElement(AllResourcesLayout, null),
        React.createElement(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", style: { width: "100%" }, spacing: 2 },
            React.createElement(Button, { variant: "contained", onClick: addResource, sx: { textTransform: "none" } }, "Add Resource"),
            React.createElement(Button, { variant: "outlined", onClick: goToArchivedResources, sx: { textTransform: "none" } }, "View Archived Resources"))));
};
